module.exports = __webpack_public_path__ + "static/56import-d51b65e20394a78eecf84e384aa8cb95.png";